/**
*  Copyright (c) 2018 Micro Focus Software Inc.  All Rights Reserved.
*
* THIS WORK IS AN UNPUBLISHED WORK AND CONTAINS CONFIDENTIAL PROPRIETARY
* AND TRADE SECRET INFORMATION OF MICRO FOCUS SOFTWARE INC. ACCESS  TO  THIS
* WORK IS RESTRICTED TO (I) MICRO FOCUS SOFTWARE INC. EMPLOYEES WHO HAVE A NEED
* TO  KNOW HOW TO  PERFORM  TASKS WITHIN  THE SCOPE  OF  THEIR   ASSIGNMENTS
* AND (II) ENTITIES OTHER  THAN  MICRO FOCUS SOFTWARE INC.  WHO  HAVE ENTERED
* INTO APPROPRIATE LICENSE   AGREEMENTS.  NO  PART  OF  THIS WORK MAY BE USED,
* PRACTICED, PERFORMED COPIED, DISTRIBUTED, REVISED, MODIFIED, TRANSLATED, ABRIDGED,
* CONDENSED, EXPANDED, COLLECTED, COMPILED, LINKED,  RECAST, TRANSFORMED
* OR ADAPTED  WITHOUT THE PRIOR WRITTEN CONSENT OF MICRO FOCUS SOFTWARE INC.
* ANY USE OR EXPLOITATION  OF  THIS WORK WITHOUT AUTHORIZATION COULD SUBJECT
* THE PERPETRATOR  TO CRIMINAL AND CIVIL LIABILITY.
*/

import { Injectable } from '@angular/core';
@Injectable()
export class InfiniteScrollService {
    private heightPerItem;
    private itemsPerRow;

    public totalNoOfItems;
    public viewStart;
    public viewEnd;
    public visibleItem;
    public totalHeight;
    public translateHeight;


    constructor() {
    }

    initialize(heightPerItem, width, totalNoOfItems, viewEnd, viewStart = 0) {
        this.heightPerItem = heightPerItem;
        this.totalNoOfItems = totalNoOfItems;
        this.viewEnd = viewEnd;
        this.viewStart = viewStart;
        this.calculateItemsPerRow(width);
        this.visibleItem = 0;
    }

    calculateItemsPerRow(width) {
        if (width >= 1200) {
            this.itemsPerRow = 6;
        } else if (width >= 992) {
            this.itemsPerRow = 4;
        } else if (width >= 768) {
            this.itemsPerRow = 3;
        } else if (width >= 576) {
            this.itemsPerRow = 3;
        } else {
            this.itemsPerRow = 2;
        }
    }

    updateTranslateValue(offset = 0) {
        this.translateHeight = 'translateY(' + ((Math.floor(this.viewStart / this.itemsPerRow) * this.heightPerItem) + offset) + 'px)';
    }

    updateTotalHeight(offset = 0) {
        this.totalHeight = (Math.ceil(this.heightPerItem * this.totalNoOfItems / this.itemsPerRow) + offset) + 'px';
    }

    updateVisibleItem(currentPos) {
        this.visibleItem = Math.ceil(currentPos / this.heightPerItem) * this.itemsPerRow;
        this.viewStart = (this.visibleItem - 12 < 0) ? 0 : this.visibleItem - 12;
        this.viewEnd = this.visibleItem + 24;
    }

    getRowWiseData(viewList) {
        let rowList = [];
        for (let i = 0; i < viewList.length; i = i + this.itemsPerRow) {
            let row = [];
            while (row.length < this.itemsPerRow) {
                let value = viewList[i + row.length];
                if (!value) {
                    break;
                }
                row.push(value);
            }
            rowList.push(row);
        }
        return rowList;
    }

    onScrollUpdate(currentPos) {
        this.updateTotalHeight();
        this.updateVisibleItem(currentPos);
        this.updateTranslateValue();
    }
}
